var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"text-center"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/branding/logo_icon_grey.svg"),"alt":"Wall collective logo icon"}}),_c('p',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.text || 'NO ITEMS'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75005ba2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Nothing.vue
// module id = null
// module chunks = 